import {Injectable} from '@angular/core';
import {ParentService} from '../../pages/A2-utils/ParentClass/ParentService';
import {Http, Response} from '@angular/http';
import { constant } from '../../app.constants';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class LyftService extends ParentService {
  constructor(private _http: Http) {
    super();
  }
  /**
   * @description para enviar trips a lyft
   */
  sendToLyft(tripId: number): Observable<any> {
    return this._http.post(`${constant.URL_SEND_TO_LYFT}/${tripId}`, {}, this.headerPost())
      .map((res: Response ) => res.json())
      .catch((error: any ) => Observable.throw(error.json()));
  }
  cancelSendToLyft(tripId: number): Observable<any> {
    return this._http.post(`${constant.URL_CANCEL_SEND_TO_LYFT}/${tripId}`, {}, this.headerPost())
      .map((res: Response ) => res.json())
      .catch((error: any ) => Observable.throw(error.json()));
  }
  /**
   * @description para verificar envio a lyft
   */
  getIsSentToLyft(tripId: number): Observable<boolean> {
    return this._http.get(`${constant.URL_VERIFY_TO_LYFT}/${tripId}` , this.getHeader() )
      .map( res => res.json())
      .catch((error: any ) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/lyft.service.ts